import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageHeader.css';

class PageHeader extends React.Component {
  render() {
    const { title } = this.props;

    return (
      <div className={styles.header}>
        <h1 className={styles.title}>
          {this._renderIcons()} <span>{title}</span>
        </h1>
        <hr />
      </div>
    );
  }

  _renderIcons = () => {
    const { icons, iconClassName } = this.props;

    if (Array.isArray(icons)) {
      return icons.map((icon, index) => (
        <img key={`icon-${index}`} src={icon} className={iconClassName} />
      ));
    }

    return <img src={icons} />;
  };
}

PageHeader.propTypes = {
  icons: PropTypes.array,
  pageTitle: PropTypes.string,
};

export default PageHeader;
